/**
 * Will normalize a duration input from milliseconds to seconds.
 *
 * @param duration
 */
export function normalizeTimingInput(duration: number) {
  // Convert to seconds
  if (duration >= 10) {
    console.warn('Transitions accept durations and delays in seconds.')
    return duration / 1000
  }

  return duration
}
